<template>
  <b-modal v-model="modalAberto" size="xl" @hidden="fecharModal" button-size="md" hide-footer
    title="Histórico Monitoramento">
    <div class="d-flex flex-wrap align-items-center justify-content-between mb-3">
      <div class="mb-2 mb-md-0">
        <b-badge :variant="aoVivo ? 'success' : 'secondary'" pill class="px-3 py-2">
          <b-icon :icon="aoVivo ? 'broadcast' : 'pause-circle'" class="mr-1" />
          {{ aoVivo ? "Tempo real ativo" : "Tempo real pausado" }}
        </b-badge>
        <small class="text-muted ml-2">Atualização a cada 5 segundos</small>
      </div>
      <div class="d-flex">
        <b-button class="mr-2" size="sm" variant="outline-primary" :disabled="busy || busyAntena" @click="loadManual">
          <b-icon icon="arrow-clockwise" class="mr-1" />
          Atualizar agora
        </b-button>
        <b-form-checkbox v-model="aoVivo" switch :value="1" :unchecked-value="0">
          <span>Atualização automática</span>
        </b-form-checkbox>
      </div>
    </div>

    <b-alert v-if="loadError" show variant="danger" class="mb-3">
      {{ loadError }}
    </b-alert>

    <b-tabs>
      <b-tab title="Eventos">
        <b-table :items="records" :fields="fields" responsive bordered hover show-empty :busy="busy"
          class="monitor-table">
          <template #table-busy>
            <div class="text-center text-primary my-2">
              <b-spinner class="align-middle mr-2"></b-spinner>
              Carregando eventos...
            </div>
          </template>

          <template #empty>
            <p class="mb-0">Nenhum evento encontrado para este item.</p>
          </template>

          <template #cell(antena)="data">
            {{ data.item.antena + (data.item.descricaoAntena ? (" - " + data.item.descricaoAntena) : "") }}
          </template>

          <template #cell(tipoEventoLeituraLeitor)="data">
            <b-badge :variant="getVariant(data.item.codTipoEventoLeituraLeitor)" class="p-2">
              <b-icon :icon="getIcon(data.item.codTipoEventoLeituraLeitor)" class="mr-1" />
              {{ data.item.tipoEventoLeituraLeitor }}
            </b-badge>
          </template>
        </b-table>

        <b-row class="align-items-center mt-3" v-if="records && records.length > 0">
          <b-col md="4" class="mb-2">
            <small class="text-muted">Página {{ page }} de {{ totalPage }} - {{ total }} registros</small>
          </b-col>
          <b-col md="4" class="mb-2">
            <div class="d-flex align-items-center">
              <small class="mr-2 text-muted">Itens por página:</small>
              <b-form-select size="sm" v-model="perPage" @change="onPerPageEventosChange" :options="perPageOptions" />
            </div>
          </b-col>
          <b-col md="4" class="mb-2">
            <div class="d-flex justify-content-md-end">
              <b-pagination v-model="page" :per-page="perPage" :total-rows="total" />
            </div>
          </b-col>
        </b-row>
      </b-tab>

      <b-tab title="Leitores">
        <b-table responsive class="mt-2" small :busy="busyAntena" :items="recordsAntena" :fields="tableFieldsAntena"
          hover show-empty>
          <template #empty>
            <p class="mb-0">Nenhum leitor encontrado para este item.</p>
          </template>

          <template #table-busy>
            <div class="text-center text-primary my-2">
              <b-spinner class="align-middle mr-2"></b-spinner>
              Carregando leitores...
            </div>
          </template>

          <template #cell(antena)="data">
            {{ data.item.antena + (data.item.descricao ? (" - " + data.item.descricao) : "") }}
          </template>
        </b-table>

        <b-row class="align-items-center mt-3" v-if="recordsAntena && recordsAntena.length > 0">
          <b-col md="4" class="mb-2">
            <small class="text-muted">Página {{ pageAntena }} de {{ totalPageAntena }} - {{ totalAntena }} registros</small>
          </b-col>
          <b-col md="4" class="mb-2">
            <div class="d-flex align-items-center">
              <small class="mr-2 text-muted">Itens por página:</small>
              <b-form-select size="sm" v-model="perPageAntena" @change="onPerPageLeitoresChange"
                :options="perPageOptions" />
            </div>
          </b-col>
          <b-col md="4" class="mb-2">
            <div class="d-flex justify-content-md-end">
              <b-pagination v-model="pageAntena" :per-page="perPageAntena" :total-rows="totalAntena" />
            </div>
          </b-col>
        </b-row>
      </b-tab>
    </b-tabs>
  </b-modal>
</template>

<script>
import { ListResourceMixin } from "@/core/mixins/resource";
import ConfirmMixin from "@/core/mixins/confirm";
import ResourceService from "@/core/api/ResourceService";
import moment from "moment";

export default {
  name: "ModalHistoricoMonitoramento",
  mixins: [ListResourceMixin, ConfirmMixin],

  props: {
    id: Number,
  },

  data() {
    return {
      aoVivo: 1,
      loading: true,
      loadError: "",
      busy: false,
      busyAntena: false,
      modalAberto: true,
      pollTimer: null,

      page: 1,
      perPage: 10,
      total: 0,
      totalPage: 0,
      records: [],

      pageAntena: 1,
      perPageAntena: 10,
      totalAntena: 0,
      totalPageAntena: 0,
      recordsAntena: [],

      filtro: {},
      filtroAntena: {},

      perPageOptions: [10, 25, 50, 100],

      fields: [
        { key: "etiqueta", label: "Etiqueta" },
        { key: "descricaoDetalhada", label: "Descrição Detalhada" },
        { key: "departamento", label: "Departamento" },
        { key: "local", label: "Local" },
        { key: "leitor", label: "Leitor" },
        { key: "antena", label: "Antena" },
        { key: "tipoAntena", label: "Tipo Antena" },
        {
          key: "dhLeitura",
          label: "Data de Leitura",
          formatter: value => !value ? "" : moment(value).format("DD/MM/YYYY HH:mm"),
        },
        { key: "tipoEventoLeituraLeitor", label: "Status" }
      ],
    };
  },

  computed: {
    tableFieldsAntena() {
      return [
        { key: "leitor", label: "Leitor" },
        { key: "antena", label: "Antena" },
        { key: "tag", label: "Etiqueta" },
        {
          key: "dhCriacao",
          label: "Data Criação",
          formatter: data => moment(String(data)).format("DD/MM/YYYY"),
        },
        {
          key: "dhLeitura",
          label: "Data Leitura",
          formatter: data => moment(String(data)).format("DD/MM/YYYY HH:mm:ss"),
        },
      ];
    },
  },

  watch: {
    page() {
      this.load();
    },
    pageAntena() {
      this.loadAntena();
    },
  },

  methods: {
    getVariant(cod) {
      switch (cod) {
        case 6: return "success";
        case 5: return "info";
        case 4: return "warning";
        case 3: return "warning";
        case 2: return "danger";
        case 1: return "secondary";
        default: return "light";
      }
    },

    getIcon(cod) {
      switch (cod) {
        case 6: return "check-circle";
        case 5: return "arrow-right-circle";
        case 4: return "box-arrow-down";
        case 3: return "box-arrow-up";
        case 2: return "exclamation-triangle";
        case 1: return "x-circle";
        default: return "question-circle";
      }
    },

    fecharModal() {
      clearTimeout(this.pollTimer);
      this.$emit("fecharModal");
    },
    onPerPageEventosChange() {
      this.page = 1;
      this.load();
    },
    onPerPageLeitoresChange() {
      this.pageAntena = 1;
      this.loadAntena();
    },

    async load() {
      this.busy = true;
      this.loadError = "";
      this.filtro = { ibp: this.id };

      try {
        const res = await this.$loadResource({
          size: this.perPage,
          page: this.page,
          params: this.filtro,
        });

        this.records = res.content || this.records;
        this.total = res.totalElements || this.total;
        this.totalPage = res.totalPages || this.totalPage;
      } catch (error) {
        this.loadError = "Não foi possível carregar os eventos do histórico.";
      } finally {
        this.busy = false;
        this.loading = false;
      }
    },

    async loadAntena() {
      this.busyAntena = true;
      this.loadError = "";
      this.filtroAntena = { ibp: this.id };

      try {
        const response = await this.$serviceAntena.findAll({
          size: this.perPageAntena,
          page: this.pageAntena,
          filter: null,
          isOrOperation: false,
          params: this.filtroAntena,
        });

        this.recordsAntena = response.data.content;
        this.totalAntena = response.data.totalElements;
        this.totalPageAntena = response.data.totalPages;
      } catch (error) {
        this.loadError = "Não foi possível carregar os leitores do histórico.";
      } finally {
        this.busyAntena = false;
      }
    },

    async loadManual() {
      this.loading = true;
      try {
        await Promise.all([this.load(), this.loadAntena()]);
      } finally {
        this.loading = false;
      }
    },

    carregarComTimer() {
      this.pollTimer = setTimeout(() => {
        if (this.aoVivo && this.modalAberto && !document.hidden) {
          this.loadManual();
        }
        this.carregarComTimer();
      }, 5000);
    },
  },

  async beforeMount() {
    this.$service = new ResourceService(`/api/evento-leitura-leitor`);
    this.$serviceAntena = new ResourceService(`/api/historico-leitura-leitor`);
    await this.loadManual();
    this.carregarComTimer();
  },
  beforeDestroy() {
    clearTimeout(this.pollTimer);
  },
};
</script>
